export const city_codes =
    [
        {
            "city_code": "101001",
            "name": "اسکو",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101002",
            "name": "ایلخچی",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101003",
            "name": "سهند",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101004",
            "name": "اهر",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101005",
            "name": "هوراند",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101006",
            "name": "آذرشهر",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101007",
            "name": "گوگان",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101008",
            "name": "ممقان",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101009",
            "name": "بستان آباد",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101010",
            "name": "تیکمه داش",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101011",
            "name": "بناب",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101012",
            "name": "باسمنج",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101013",
            "name": "تبریز",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101014",
            "name": "خسروشهر",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101015",
            "name": "سردرود",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101016",
            "name": "جلفا",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101017",
            "name": "سیه رود",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101018",
            "name": "هادیشهر",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101019",
            "name": "قره آغاج",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101020",
            "name": "خمارلو",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101021",
            "name": "دوزدوزان",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101022",
            "name": "سراب",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101023",
            "name": "شربیان",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101024",
            "name": "مهربان",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101025",
            "name": "تسوج",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101026",
            "name": "خامنه",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101027",
            "name": "سیس",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101028",
            "name": "شبستر",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101029",
            "name": "شرفخانه",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101030",
            "name": "شندآباد",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101031",
            "name": "صوفیان",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101032",
            "name": "کوزه کنان",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101033",
            "name": "وایقان",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101034",
            "name": "عجب شیر",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101035",
            "name": "آبش احمد",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101036",
            "name": "کلیبر",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101037",
            "name": "خداجو[1]",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101038",
            "name": "مراغه",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101039",
            "name": "بناب جدید",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101040",
            "name": "زنوز",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101041",
            "name": "کشکسرای",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101042",
            "name": "مرند",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101043",
            "name": "یامچی",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101044",
            "name": "لیلان",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101045",
            "name": "ملکان",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101046",
            "name": "آقکند",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101047",
            "name": "ترک",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101048",
            "name": "ترکمانچای",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101049",
            "name": "میانه",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101050",
            "name": "بخشایش",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101051",
            "name": "خواجه",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101052",
            "name": "زرنق",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101053",
            "name": "کلوانق",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101054",
            "name": "هریس",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101055",
            "name": "نظرکهریزی",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101056",
            "name": "هشترود",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101057",
            "name": "خاروانا",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101058",
            "name": "ورزقان",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "101063",
            "name": "اربطان",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "city_code": "102001",
            "name": "ارومیه",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102002",
            "name": "سرو",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102003",
            "name": "سیلوانه",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102004",
            "name": "قوشچی",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102005",
            "name": "نوشین",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102006",
            "name": "اشنویه",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102007",
            "name": "نالوس",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102008",
            "name": "بوکان",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102009",
            "name": "سیمینه",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102010",
            "name": "پلدشت",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102011",
            "name": "نازک علیا",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102012",
            "name": "پیرانشهر",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102013",
            "name": "گردکشانه",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102014",
            "name": "تکاب",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102015",
            "name": "آواجیق",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102016",
            "name": "سیه چشمه",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102017",
            "name": "قره ضیاء الدین",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102018",
            "name": "ایواوغلی",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102019",
            "name": "خوی",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102020",
            "name": "دیزج دیز",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102021",
            "name": "زرآباد",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102022",
            "name": "فیرورق",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102023",
            "name": "قطور",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102024",
            "name": "ربط",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102025",
            "name": "سردشت",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102026",
            "name": "میرآباد",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102027",
            "name": "تازه شهر",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102028",
            "name": "سلماس",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102029",
            "name": "شاهین دژ",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102030",
            "name": "کشاورز",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102031",
            "name": "محمودآباد",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102032",
            "name": "شوط",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102033",
            "name": "مرگنلر",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102034",
            "name": "بازرگان",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102035",
            "name": "ماکو",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102036",
            "name": "خلیفان",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102037",
            "name": "مهاباد",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102038",
            "name": "باروق",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102039",
            "name": "چهاربرج",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102040",
            "name": "میاندوآب",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102041",
            "name": "محمدیار",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "102042",
            "name": "نقده",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "city_code": "103001",
            "name": "اردبیل",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103002",
            "name": "هیر",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103003",
            "name": "بیله سوار",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103004",
            "name": "جعفرآباد",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103005",
            "name": "اصلاندوز",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103006",
            "name": "پارس آباد",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103007",
            "name": "تازه کند",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103008",
            "name": "خلخال",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103009",
            "name": "کلور",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103010",
            "name": "هشتجین",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103011",
            "name": "سرعین",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103012",
            "name": "گیوی",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103013",
            "name": "تازه کندانگوت",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103014",
            "name": "گرمی",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103015",
            "name": "رضی",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103016",
            "name": "فخرآباد",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103017",
            "name": "لاهرود",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103018",
            "name": "مرادلو",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103019",
            "name": "مشگین شهر",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103020",
            "name": "آبی بیگلو",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103021",
            "name": "عنبران",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103022",
            "name": "نمین",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103023",
            "name": "کوراییم",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103024",
            "name": "نیر",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "104001",
            "name": "اردستان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104002",
            "name": "زواره",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104003",
            "name": "مهاباد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104004",
            "name": "اژیه",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104005",
            "name": "اصفهان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104006",
            "name": "بهارستان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104007",
            "name": "تودشک",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104008",
            "name": "حسن اباد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104009",
            "name": "خوراسگان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104010",
            "name": "سگزی",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104011",
            "name": "کوهپایه",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104012",
            "name": "محمدآباد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104013",
            "name": "نصرآباد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104014",
            "name": "نیک آباد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104015",
            "name": "هرند",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104016",
            "name": "ورزنه",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104017",
            "name": "ابوزیدآباد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104018",
            "name": "آران وبیدگل",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104019",
            "name": "سفیدشهر",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104020",
            "name": "نوش آباد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104021",
            "name": "حبیب آباد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104022",
            "name": "خورزوق",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104023",
            "name": "دستگرد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104024",
            "name": "دولت آباد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104025",
            "name": "شاپورآباد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104026",
            "name": "کمشچه",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104027",
            "name": "تیران",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104028",
            "name": "رضوانشهر",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104029",
            "name": "عسگران",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104030",
            "name": "چادگان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104031",
            "name": "رزوه",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104032",
            "name": "خمینی شهر",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104033",
            "name": "درچه",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104034",
            "name": "کوشک",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104035",
            "name": "خوانسار",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104036",
            "name": "جندق",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104037",
            "name": "خور",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104038",
            "name": "فرخی",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104039",
            "name": "دهاقان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104040",
            "name": "گلشن",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104041",
            "name": "حنا",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104042",
            "name": "سمیرم",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104043",
            "name": "کمه",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104044",
            "name": "ونک",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104045",
            "name": "شاهین شهر",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104046",
            "name": "گرگاب",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104047",
            "name": "گزبرخوار",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104048",
            "name": "لای بید",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104049",
            "name": "میمه",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104050",
            "name": "وزوان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104051",
            "name": "شهرضا",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104052",
            "name": "منظریه",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104053",
            "name": "افوس",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104054",
            "name": "بویین ومیاندشت",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104055",
            "name": "داران",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104056",
            "name": "دامنه",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104057",
            "name": "برف انبار",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104058",
            "name": "فریدونشهر",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104059",
            "name": "ابریشم",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104060",
            "name": "ایمانشهر",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104061",
            "name": "بهاران شهر",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104062",
            "name": "پیربکران",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104063",
            "name": "فلاورجان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104064",
            "name": "قهدریجان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104065",
            "name": "کلیشادوسودرجان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104066",
            "name": "برزک",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104067",
            "name": "جوشقان وکامو",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104068",
            "name": "قمصر",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104069",
            "name": "کاشان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104070",
            "name": "مشکات",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104071",
            "name": "نیاسر",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104072",
            "name": "گلپایگان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104073",
            "name": "گلشهر",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104074",
            "name": "گوگد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104075",
            "name": "باغ بهادران",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104076",
            "name": "چرمهین",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104077",
            "name": "چمگردان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104078",
            "name": "زاینده رود",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104079",
            "name": "زرین شهر",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104080",
            "name": "سده لنجان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104081",
            "name": "فولادشهر",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104082",
            "name": "ورنامخواست",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104083",
            "name": "دیزیچه",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104084",
            "name": "زیباشهر",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104085",
            "name": "طالخونچه",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104086",
            "name": "کرکوند",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104087",
            "name": "مبارکه",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104088",
            "name": "مجلسی",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104089",
            "name": "انارک",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104090",
            "name": "بافران",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104091",
            "name": "نایین",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104092",
            "name": "جوزدان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104093",
            "name": "دهق",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104094",
            "name": "علویجه",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104095",
            "name": "کهریزسنگ",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104096",
            "name": "گلدشت",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104097",
            "name": "نجف آباد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104098",
            "name": "بادرود",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104099",
            "name": "خالدآباد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104100",
            "name": "نطنز",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "105001",
            "name": "چهارباغ",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105002",
            "name": "شهرجدیدهشتگرد",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105003",
            "name": "کوهسار",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105004",
            "name": "گلسار",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105005",
            "name": "هشتگرد",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105006",
            "name": "طالقان",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105007",
            "name": "اشتهارد",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105008",
            "name": "آسارا",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105009",
            "name": "کرج",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105010",
            "name": "کمال شهر",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105011",
            "name": "گرمدره",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105012",
            "name": "ماهدشت",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105013",
            "name": "محمدشهر",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105014",
            "name": "مشکین دشت",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105015",
            "name": "تنکمان",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105016",
            "name": "نظرآباد",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105017",
            "name": "فردیس",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "106001",
            "name": "ایلام",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106002",
            "name": "چوار",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106003",
            "name": "ایوان",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106004",
            "name": "زرنه",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106005",
            "name": "آبدانان",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106006",
            "name": "سراب باغ",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106007",
            "name": "مورموری",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106008",
            "name": "بدره",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106009",
            "name": "دره شهر",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106010",
            "name": "پهله",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106011",
            "name": "دهلران",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106012",
            "name": "موسیان",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106013",
            "name": "میمه",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106014",
            "name": "آسمان آباد",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106015",
            "name": "توحید",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106016",
            "name": "سرابله",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106017",
            "name": "لومار",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106018",
            "name": "ارکواز",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106019",
            "name": "دلگشا",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106020",
            "name": "صالح آباد",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "106021",
            "name": "مهران",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "107001",
            "name": "بوشهر",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107002",
            "name": "چغادک",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107003",
            "name": "خارک",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107004",
            "name": "اهرم",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107005",
            "name": "دلوار",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107006",
            "name": "انارستان",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107007",
            "name": "جم",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107008",
            "name": "ریز",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107009",
            "name": "آب پخش",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107010",
            "name": "برازجان",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107011",
            "name": "تنگ ارم",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107012",
            "name": "دالکی",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107013",
            "name": "سعد آباد",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107014",
            "name": "شبانکاره",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107015",
            "name": "کلمه",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107016",
            "name": "وحدتیه",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107017",
            "name": "خورموج",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107018",
            "name": "شنبه",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107019",
            "name": "کاکی",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107020",
            "name": "آبدان",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107021",
            "name": "بردخون",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107022",
            "name": "بردستان",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107023",
            "name": "بندردیر",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107024",
            "name": "امام حسن",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107025",
            "name": "بندردیلم",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107026",
            "name": "بندرکنگان",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107027",
            "name": "بنک",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107028",
            "name": "سیراف",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107029",
            "name": "عسلویه",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107030",
            "name": "نخل تقی",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107031",
            "name": "بندرریگ",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107032",
            "name": "بندرگناوه",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "108001",
            "name": "اسلامشهر",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108002",
            "name": "چهاردانگه",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108003",
            "name": "صالح آباد",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108004",
            "name": "گلستان",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108005",
            "name": "نسیم شهر",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108006",
            "name": "پاکدشت",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108007",
            "name": "شریف آباد",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108008",
            "name": "فرون آباد",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108009",
            "name": "پیشوا",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108010",
            "name": "بومهن",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108011",
            "name": "پردیس",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108012",
            "name": "تهران",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108013",
            "name": "آبسرد",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108014",
            "name": "آبعلی",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108015",
            "name": "دماوند",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108016",
            "name": "رودهن",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108017",
            "name": "کیلان",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108018",
            "name": "رباط کریم",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108019",
            "name": "نصیرشهر",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108020",
            "name": "باقرشهر",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108021",
            "name": "حسن آباد",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108022",
            "name": "کهریزک",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108023",
            "name": "فشم",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108024",
            "name": "لواسان",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108025",
            "name": "اندیشه",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108026",
            "name": "باغستان",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108027",
            "name": "شاهدشهر",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108028",
            "name": "شهریار",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108029",
            "name": "صباشهر",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108030",
            "name": "فردوسیه",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108031",
            "name": "وحیدیه",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108032",
            "name": "ارجمند",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108033",
            "name": "فیروزکوه",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108034",
            "name": "قدس",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108035",
            "name": "صفادشت",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108036",
            "name": "ملارد",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108037",
            "name": "جوادآباد",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108038",
            "name": "قرچک",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108039",
            "name": "ورامین",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108040",
            "name": "شهرجدید پرند",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108041",
            "name": "ری",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108042",
            "name": "شمشک",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108027",
            "name": "شاهد شهر",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "109001",
            "name": "اردل",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109002",
            "name": "بروجن",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109003",
            "name": "بلداجی",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109004",
            "name": "سفیددشت",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109005",
            "name": "فرادنبه",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109006",
            "name": "گندمان",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109007",
            "name": "نقنه",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109008",
            "name": "بن",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109009",
            "name": "سامان",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109010",
            "name": "سودجان",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109011",
            "name": "سورشجان",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109012",
            "name": "شهرکرد",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109013",
            "name": "طاقانک",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109014",
            "name": "فرخ شهر",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109015",
            "name": "کیان",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109016",
            "name": "نافچ",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109017",
            "name": "هفشجان",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109018",
            "name": "وردنجان",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109019",
            "name": "باباحیدر",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109020",
            "name": "پردنجان",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109021",
            "name": "جونقان",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109022",
            "name": "فارسان",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109023",
            "name": "چلگرد",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109024",
            "name": "دستنا",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109025",
            "name": "شلمزار",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109026",
            "name": "گهرو",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109027",
            "name": "ناغان",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109028",
            "name": "آلونی",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109029",
            "name": "لردگان",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109030",
            "name": "مال خلیفه",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109031",
            "name": "منج",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109032",
            "name": "دشتک",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109033",
            "name": "سرخون",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109034",
            "name": "کاج",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109035",
            "name": "گوجان",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109036",
            "name": "چلیچه",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109037",
            "name": "صمصامی",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109038",
            "name": "بازفت",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109024",
            "name": "دستناء",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "109041",
            "name": "یان چشمه",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "city_code": "110001",
            "name": "ارسک",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110002",
            "name": "بشرویه",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110003",
            "name": "بیرجند",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110004",
            "name": "خوسف",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110005",
            "name": "محمدشهر",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110006",
            "name": "اسدیه",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110007",
            "name": "طبس مسینا",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110008",
            "name": "قهستان",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110009",
            "name": "گزیک",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110010",
            "name": "آیسک",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110011",
            "name": "سرایان",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110012",
            "name": "سه قلعه",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110013",
            "name": "سربیشه",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110014",
            "name": "مود",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110015",
            "name": "اسلامیه",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110016",
            "name": "فردوس",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110017",
            "name": "اسفدن",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110018",
            "name": "آرین شهر",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110019",
            "name": "حاجی آباد",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110020",
            "name": "خضری دشت بیاض",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110021",
            "name": "زهان",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110022",
            "name": "قاین",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110023",
            "name": "نیمبلوک",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110024",
            "name": "شوسف",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110025",
            "name": "نهبندان",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110026",
            "name": "دیهوک",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110027",
            "name": "طبس",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "110028",
            "name": "عشق آباد",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "111001",
            "name": "باخرز",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111002",
            "name": "بجستان",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111003",
            "name": "یونسی",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111004",
            "name": "انابد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111005",
            "name": "بردسکن",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111006",
            "name": "شهرآباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111007",
            "name": "شاندیز",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111008",
            "name": "طرقبه",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111009",
            "name": "تایباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111010",
            "name": "کاریز",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111011",
            "name": "مشهدریزه",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111012",
            "name": "فیروزه",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111013",
            "name": "همت آباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111014",
            "name": "احمدابادصولت",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111015",
            "name": "تربت جام",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111016",
            "name": "صالح آباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111017",
            "name": "نصرآباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111018",
            "name": "نیل شهر",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111019",
            "name": "بایک",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111020",
            "name": "تربت حیدریه",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111021",
            "name": "رباط سنگ",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111022",
            "name": "کدکن",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111023",
            "name": "جغتای",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111024",
            "name": "نقاب",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111025",
            "name": "چناران",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111026",
            "name": "گلمکان",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111027",
            "name": "خلیل آباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111028",
            "name": "کندر",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111029",
            "name": "خواف",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111030",
            "name": "سلامی",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111031",
            "name": "سنگان",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111032",
            "name": "قاسم آباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111033",
            "name": "نشتیفان",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111034",
            "name": "سلطان آباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111035",
            "name": "چاپشلو",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111036",
            "name": "درگز",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111037",
            "name": "لطف آباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111038",
            "name": "نوخندان",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111039",
            "name": "جنگل",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111040",
            "name": "رشتخوار",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111041",
            "name": "دولت آباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111042",
            "name": "داورزن",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111043",
            "name": "روداب",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111044",
            "name": "سبزوار",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111045",
            "name": "ششتمد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111046",
            "name": "سرخس",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111047",
            "name": "مزدآوند",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111048",
            "name": "سفیدسنگ",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111049",
            "name": "فرهادگرد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111050",
            "name": "فریمان",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111051",
            "name": "قلندرآباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111052",
            "name": "باجگیران",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111053",
            "name": "قوچان",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111054",
            "name": "ریوش",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111055",
            "name": "کاشمر",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111056",
            "name": "شهرزو",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111057",
            "name": "کلات",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111058",
            "name": "بیدخت",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111059",
            "name": "کاخک",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111060",
            "name": "گناباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111061",
            "name": "رضویه",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111062",
            "name": "مشهد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111063",
            "name": "مشهد ثامن",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111064",
            "name": "ملک آباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111065",
            "name": "شادمهر",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111066",
            "name": "فیض آباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111067",
            "name": "بار",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111068",
            "name": "چکنه",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111069",
            "name": "خرو",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111070",
            "name": "درود",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111071",
            "name": "عشق آباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111072",
            "name": "قدمگاه",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111073",
            "name": "نیشابور",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111074",
            "name": "اسحق اباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "112001",
            "name": "اسفراین",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112002",
            "name": "صفی آباد",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112003",
            "name": "بجنورد",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112004",
            "name": "حصارگرمخان",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112005",
            "name": "راز",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112006",
            "name": "جاجرم",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112007",
            "name": "سنخواست",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112008",
            "name": "شوقان",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112009",
            "name": "شیروان",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112010",
            "name": "لوجلی",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112011",
            "name": "تیتکانلو",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112012",
            "name": "فاروج",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112013",
            "name": "ایور",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112014",
            "name": "درق",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112015",
            "name": "گرمه",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112016",
            "name": "آشخانه",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112017",
            "name": "پیش قلعه",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112018",
            "name": "قاضی",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112019",
            "name": "خانلق",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "112021",
            "name": "اوا",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "113001",
            "name": "امیدیه",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113002",
            "name": "جایزان",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113003",
            "name": "قلعه خواجه",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113004",
            "name": "اندیمشک",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113005",
            "name": "حسینیه",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113006",
            "name": "اهواز",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113007",
            "name": "حمیدیه",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113008",
            "name": "ایذه",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113009",
            "name": "دهدز",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113010",
            "name": "اروندکنار",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113011",
            "name": "آبادان",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113012",
            "name": "چویبده",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113013",
            "name": "باغ ملک",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113014",
            "name": "صیدون",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113015",
            "name": "قلعه تل",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113016",
            "name": "میداود",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113017",
            "name": "شیبان",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113018",
            "name": "ملاثانی",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113019",
            "name": "ویس",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113020",
            "name": "بندرامام خمینی",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113021",
            "name": "بندرماهشهر",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113022",
            "name": "چمران",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113023",
            "name": "آغاجاری",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113024",
            "name": "بهبهان",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113025",
            "name": "سردشت",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113026",
            "name": "خرمشهر",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113027",
            "name": "مینوشهر",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113028",
            "name": "چغامیش",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113029",
            "name": "حمزه",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113030",
            "name": "دزآب",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113031",
            "name": "دزفول",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113032",
            "name": "سالند",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113033",
            "name": "صفی آباد",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113034",
            "name": "میانرود",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113035",
            "name": "بستان",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113036",
            "name": "سوسنگرد",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113037",
            "name": "رامشیر",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113038",
            "name": "مشراگه",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113039",
            "name": "رامهرمز",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113040",
            "name": "دارخوین",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113041",
            "name": "شادگان",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113042",
            "name": "الوان",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113043",
            "name": "حر",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113044",
            "name": "شاوور",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113045",
            "name": "شوش",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113046",
            "name": "صالح مشطت",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113047",
            "name": "شرافت",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113048",
            "name": "شوشتر",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113049",
            "name": "گوریه",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113050",
            "name": "ترکالکی",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113051",
            "name": "جنت مکان",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113052",
            "name": "سماله",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113053",
            "name": "صالح شهر",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113054",
            "name": "گتوند",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113055",
            "name": "لالی",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113056",
            "name": "مسجدسلیمان",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113057",
            "name": "هفتگل",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113058",
            "name": "زهره",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113059",
            "name": "هندیجان",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113060",
            "name": "رفیع",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113061",
            "name": "هویزه",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113062",
            "name": "ازادی",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113074",
            "name": "بیدروبه",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "114001",
            "name": "ابهر",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114002",
            "name": "سلطانیه",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114003",
            "name": "صایین قلعه",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114004",
            "name": "هیدج",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114005",
            "name": "حلب",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114006",
            "name": "زرین آباد",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114007",
            "name": "زرین رود",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114008",
            "name": "سجاس",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114009",
            "name": "سهرورد",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114010",
            "name": "قیدار",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114011",
            "name": "گرماب",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114012",
            "name": "خرمدره",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114013",
            "name": "ارمغانخانه",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114014",
            "name": "زنجان",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114015",
            "name": "آب بر",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114016",
            "name": "چورزق",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114017",
            "name": "دندی",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "114018",
            "name": "ماه نشان",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "115001",
            "name": "امیریه",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115002",
            "name": "دامغان",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115003",
            "name": "دیباج",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115004",
            "name": "سرخه",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115005",
            "name": "سمنان",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115006",
            "name": "بسطام",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115007",
            "name": "بیارجمند",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115008",
            "name": "شاهرود",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115009",
            "name": "کلاته خیج",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115010",
            "name": "مجن",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115011",
            "name": "میامی",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115012",
            "name": "ایوانکی",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115013",
            "name": "آرادان",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115014",
            "name": "گرمسار",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115015",
            "name": "درجزین",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115016",
            "name": "شهمیرزاد",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115017",
            "name": "مهدی شهر",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "116001",
            "name": "ایرانشهر",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116002",
            "name": "بزمان",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116003",
            "name": "بمپور",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116004",
            "name": "محمدان",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116005",
            "name": "چابهار",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116006",
            "name": "نگور",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116007",
            "name": "خاش",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116008",
            "name": "نوک آباد",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116009",
            "name": "گلمورتی",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116010",
            "name": "بنجار",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116011",
            "name": "زابل",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116012",
            "name": "زاهدان",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116013",
            "name": "میرجاوه",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116014",
            "name": "نصرت آباد",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116015",
            "name": "زهک",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116016",
            "name": "جالق",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116017",
            "name": "سراوان",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116018",
            "name": "سیرکان",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116019",
            "name": "گشت",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116020",
            "name": "محمدی",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116021",
            "name": "پیشین",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116022",
            "name": "راسک",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116023",
            "name": "سرباز",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116024",
            "name": "سوران",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116025",
            "name": "هیدوچ",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116026",
            "name": "زرآباد",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116027",
            "name": "کنارک",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116028",
            "name": "زابلی",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116029",
            "name": "اسپکه",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116030",
            "name": "بنت",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116031",
            "name": "فنوج",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116032",
            "name": "قصرقند",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116033",
            "name": "نیک شهر",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116034",
            "name": "ادیمی",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116035",
            "name": "علی اکبر",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116052",
            "name": "چانف",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116044",
            "name": "سیب",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "116053",
            "name": "سرجنگل",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "city_code": "117001",
            "name": "ارسنجان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117002",
            "name": "استهبان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117003",
            "name": "ایج",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117004",
            "name": "رونیز",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117005",
            "name": "اقلید",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117006",
            "name": "حسن آباد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117007",
            "name": "دژکرد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117008",
            "name": "سده",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117009",
            "name": "ایزدخواست",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117010",
            "name": "آباده",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117011",
            "name": "بهمن",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117012",
            "name": "سورمق",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117013",
            "name": "صغاد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117014",
            "name": "بوانات",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117015",
            "name": "حسامی",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117016",
            "name": "کره ای",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117017",
            "name": "سعادت شهر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117018",
            "name": "باب انار",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117019",
            "name": "جهرم",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117020",
            "name": "خاوران",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117021",
            "name": "دوزه",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117022",
            "name": "قطب آباد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117023",
            "name": "خرامه",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117024",
            "name": "صفاشهر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117025",
            "name": "قادرآباد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117026",
            "name": "خنج",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117027",
            "name": "جنت شهر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117028",
            "name": "داراب",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117029",
            "name": "دوبرجی",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117030",
            "name": "فدامی",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117031",
            "name": "مصیری",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117032",
            "name": "حاجی آباد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117033",
            "name": "دبیران",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117034",
            "name": "شهرپیر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117035",
            "name": "اردکان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117036",
            "name": "بیضا",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117037",
            "name": "هماشهر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117038",
            "name": "سروستان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117039",
            "name": "کوهنجان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117040",
            "name": "خانه زنیان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117041",
            "name": "داریان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117042",
            "name": "زرقان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117043",
            "name": "شهرصدرا",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117044",
            "name": "شیراز",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117045",
            "name": "لپویی",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117046",
            "name": "دهرم",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117047",
            "name": "فراشبند",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117048",
            "name": "نوجین",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117049",
            "name": "زاهدشهر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117050",
            "name": "ششده",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117051",
            "name": "فسا",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117052",
            "name": "نوبندگان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117053",
            "name": "فیروزآباد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117054",
            "name": "میمند",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117055",
            "name": "افزر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117056",
            "name": "امام شهر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117057",
            "name": "قیر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117058",
            "name": "کارزین[2]",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117060",
            "name": "بالاده",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117061",
            "name": "خشت",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117062",
            "name": "قایمیه",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117063",
            "name": "کازرون",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117064",
            "name": "کنارتخته",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117065",
            "name": "نودان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117066",
            "name": "کوار",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117067",
            "name": "گراش",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117068",
            "name": "اوز",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117069",
            "name": "بنارویه",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117070",
            "name": "بیرم",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117071",
            "name": "جویم",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117072",
            "name": "خور",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117074",
            "name": "لار",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117075",
            "name": "لطیفی",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117076",
            "name": "اشکنان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117077",
            "name": "اهل",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117078",
            "name": "علامرودشت",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117079",
            "name": "لامرد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117080",
            "name": "رامجرد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117081",
            "name": "سیدان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117082",
            "name": "کامفیروز",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117083",
            "name": "مرودشت",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117084",
            "name": "خومه زار",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117085",
            "name": "نورآباد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117086",
            "name": "اسیر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117087",
            "name": "گله دار",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117088",
            "name": "مهر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117089",
            "name": "وراوی",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117090",
            "name": "آباده طشک",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117091",
            "name": "قطرویه",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117092",
            "name": "مشکان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117093",
            "name": "نی ریز",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117059",
            "name": "مبارک اباد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "118001",
            "name": "الوند",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118002",
            "name": "بیدستان",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118003",
            "name": "شریفیه",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118004",
            "name": "محمدیه",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118005",
            "name": "آبیک",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118006",
            "name": "خاکعلی",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118007",
            "name": "ارداق",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118008",
            "name": "آبگرم",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118009",
            "name": "آوج",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118010",
            "name": "بویین زهرا",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118011",
            "name": "دانسفهان",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118012",
            "name": "سگزآباد",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118013",
            "name": "شال",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118014",
            "name": "اسفرورین",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118015",
            "name": "تاکستان",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118016",
            "name": "خرمدشت",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118017",
            "name": "ضیاءآباد",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118018",
            "name": "نرجه",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118019",
            "name": "اقبالیه",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118020",
            "name": "رازمیان",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118021",
            "name": "سیردان",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118022",
            "name": "قزوین",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118023",
            "name": "کوهین",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118024",
            "name": "محمودآبادنمونه",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118025",
            "name": "معلم کلایه",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "118027",
            "name": "قشلاق",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "119001",
            "name": "جعفریه",
            "province_id": "19",
            "province_code": "QOM "
        },
        {
            "city_code": "119002",
            "name": "دستجرد",
            "province_id": "19",
            "province_code": "QOM "
        },
        {
            "city_code": "119003",
            "name": "سلفچگان",
            "province_id": "19",
            "province_code": "QOM "
        },
        {
            "city_code": "119004",
            "name": "قم",
            "province_id": "19",
            "province_code": "QOM "
        },
        {
            "city_code": "119005",
            "name": "قنوات",
            "province_id": "19",
            "province_code": "QOM "
        },
        {
            "city_code": "119006",
            "name": "کهک",
            "province_id": "19",
            "province_code": "QOM "
        },
        {
            "city_code": "120001",
            "name": "آرمرده",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120002",
            "name": "بانه",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120003",
            "name": "بویین سفلی",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120004",
            "name": "کانی سور",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120005",
            "name": "بابارشانی",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120006",
            "name": "بیجار",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120007",
            "name": "یاسوکند",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120008",
            "name": "بلبان آباد",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120009",
            "name": "دهگلان",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120010",
            "name": "دیواندره",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120011",
            "name": "زرینه",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120012",
            "name": "سروآباد",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120013",
            "name": "سقز",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120014",
            "name": "صاحب",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120015",
            "name": "سنندج",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120016",
            "name": "شویشه",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120017",
            "name": "دزج",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120018",
            "name": "دلبران",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120019",
            "name": "سریش آباد",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120020",
            "name": "قروه",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120021",
            "name": "کامیاران",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120022",
            "name": "موچش",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120023",
            "name": "چناره",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120024",
            "name": "کانی دینار",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120025",
            "name": "مریوان",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "120033",
            "name": "هزارکانیان",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "121001",
            "name": "ارزوییه",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121002",
            "name": "امین شهر",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121003",
            "name": "انار",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121004",
            "name": "بافت",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121005",
            "name": "بزنجان",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121006",
            "name": "بردسیر",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121007",
            "name": "گلزار",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121008",
            "name": "لاله زار",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121009",
            "name": "نگار",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121010",
            "name": "بروات",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121011",
            "name": "بم",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121012",
            "name": "جبالبارز",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121013",
            "name": "جیرفت",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121014",
            "name": "درب بهشت",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121015",
            "name": "رابر",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121016",
            "name": "راور",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121017",
            "name": "هجدک",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121018",
            "name": "بهرمان",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121019",
            "name": "رفسنجان",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121020",
            "name": "صفاییه",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121021",
            "name": "کشکوییه",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121022",
            "name": "مس سرچشمه",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121023",
            "name": "رودبار",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121024",
            "name": "محمدآباد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121025",
            "name": "خانوک",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121026",
            "name": "ریحان",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121027",
            "name": "زرند",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121028",
            "name": "یزدان شهر",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121029",
            "name": "پاریز",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121030",
            "name": "زیدآباد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121031",
            "name": "سیرجان",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121032",
            "name": "نجف شهر",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121033",
            "name": "هماشهر",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121034",
            "name": "جوزم",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121035",
            "name": "خاتون آباد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121036",
            "name": "خورسند",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121037",
            "name": "دهج",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121038",
            "name": "شهربابک",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121039",
            "name": "دوساری",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121040",
            "name": "عنبرآباد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121041",
            "name": "مردهک",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121042",
            "name": "فاریاب",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121043",
            "name": "فهرج",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121044",
            "name": "قلعه گنج",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121045",
            "name": "اختیارآباد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121046",
            "name": "اندوهجرد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121047",
            "name": "باغین",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121048",
            "name": "جوپار",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121049",
            "name": "چترود",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121050",
            "name": "راین",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121051",
            "name": "زنگی آباد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121052",
            "name": "شهداد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121053",
            "name": "کاظم آباد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121054",
            "name": "کرمان",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121055",
            "name": "گلباف",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121056",
            "name": "ماهان",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121057",
            "name": "محی آباد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121058",
            "name": "کهنوج",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121059",
            "name": "کوهبنان",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121060",
            "name": "کیانشهر",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121061",
            "name": "منوجان",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121062",
            "name": "نودژ",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121063",
            "name": "نرماشیر",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121064",
            "name": "نظام شهر",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121068",
            "name": "خواجوشهر",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121076",
            "name": "رمشک",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121081",
            "name": "عباس ابادسردار",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121079",
            "name": "جوادیه الهیه",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "122001",
            "name": "اسلام آبادغرب",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122002",
            "name": "حمیل",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122003",
            "name": "باینگان",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122004",
            "name": "پاوه",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122005",
            "name": "نودشه",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122006",
            "name": "نوسود",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122007",
            "name": "ازگله",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122008",
            "name": "تازه آباد",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122009",
            "name": "جوانرود",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122010",
            "name": "کرند",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122011",
            "name": "گهواره",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122012",
            "name": "روانسر",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122013",
            "name": "شاهو",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122014",
            "name": "سرپل ذهاب",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122015",
            "name": "سطر",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122016",
            "name": "سنقر",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122017",
            "name": "صحنه",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122018",
            "name": "میان راهان",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122019",
            "name": "سومار",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122020",
            "name": "قصرشیرین",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122021",
            "name": "رباط",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122022",
            "name": "کرمانشاه",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122023",
            "name": "کوزران",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122024",
            "name": "هلشی",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122025",
            "name": "کنگاور",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122026",
            "name": "سرمست",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122027",
            "name": "گیلانغرب",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122028",
            "name": "بیستون",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122029",
            "name": "هرسین",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122030",
            "name": "میراباد",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "123001",
            "name": "باشت",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123002",
            "name": "لیکک",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123003",
            "name": "گراب سفلی",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123004",
            "name": "مادوان",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123005",
            "name": "مارگون",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123006",
            "name": "یاسوج",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123007",
            "name": "چرام",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123008",
            "name": "پاتاوه",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123009",
            "name": "چیتاب",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123010",
            "name": "سی سخت",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123011",
            "name": "دهدشت",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123012",
            "name": "دیشموک",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123013",
            "name": "سوق",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123014",
            "name": "قلعه رییسی",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123015",
            "name": "لنده",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "123016",
            "name": "دوگنبدان",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "city_code": "124001",
            "name": "آزادشهر",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124002",
            "name": "نگین شهر",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124003",
            "name": "نوده خاندوز",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124004",
            "name": "انبارآلوم",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124005",
            "name": "آق قلا",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124006",
            "name": "بندرگز",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124007",
            "name": "نوکنده",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124008",
            "name": "بندرترکمن",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124009",
            "name": "خان ببین",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124010",
            "name": "دلند",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124011",
            "name": "رامیان",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124012",
            "name": "علی آباد",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124013",
            "name": "فاضل آباد",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124014",
            "name": "کردکوی",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124015",
            "name": "کلاله",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124016",
            "name": "گالیکش",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124017",
            "name": "جلین",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124018",
            "name": "سرخنکلاته",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124019",
            "name": "گرگان",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124020",
            "name": "سیمین شهر",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124021",
            "name": "گمیش تپه",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124022",
            "name": "اینچه برون",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124023",
            "name": "گنبدکاووس",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124024",
            "name": "مراوه",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124025",
            "name": "مینودشت",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "125001",
            "name": "املش",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125002",
            "name": "رانکوه",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125003",
            "name": "آستارا",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125004",
            "name": "لوندویل",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125005",
            "name": "آستانه اشرفیه",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125006",
            "name": "کیاشهر",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125007",
            "name": "بندرانزلی",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125008",
            "name": "اسالم",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125009",
            "name": "تالش",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125010",
            "name": "چوبر",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125011",
            "name": "حویق",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125012",
            "name": "لیسار",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125013",
            "name": "خشکبیجار",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125014",
            "name": "خمام",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125015",
            "name": "رشت",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125016",
            "name": "سنگر",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125017",
            "name": "کوچصفهان",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125018",
            "name": "لشت نشا",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125019",
            "name": "لولمان",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125020",
            "name": "پره سر",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125021",
            "name": "رضوانشهر",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125022",
            "name": "بره سر",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125023",
            "name": "توتکابن",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125024",
            "name": "جیرنده",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125025",
            "name": "رستم آباد",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125026",
            "name": "رودبار",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125027",
            "name": "لوشان",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125028",
            "name": "منجیل",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125029",
            "name": "چابکسر",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125030",
            "name": "رحیم آباد",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125031",
            "name": "رودسر",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125032",
            "name": "کلاچای",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125033",
            "name": "واجارگاه",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125034",
            "name": "دیلمان",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125035",
            "name": "سیاهکل",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125036",
            "name": "احمدسرگوراب",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125037",
            "name": "شفت",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125038",
            "name": "صومعه سرا",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125039",
            "name": "گوراب زرمیخ",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125040",
            "name": "مرجقل",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125041",
            "name": "فومن",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125042",
            "name": "ماسوله",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125043",
            "name": "رودبنه",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125044",
            "name": "لاهیجان",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125045",
            "name": "اطاقور",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125046",
            "name": "چاف و چمخاله",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125047",
            "name": "شلمان",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125048",
            "name": "کومله",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125049",
            "name": "لنگرود",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125050",
            "name": "بازارجمعه",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125051",
            "name": "ماسال",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "126001",
            "name": "ازنا",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126002",
            "name": "مومن آباد",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126003",
            "name": "الیگودرز",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126004",
            "name": "شول آباد",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126005",
            "name": "اشترینان",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126006",
            "name": "بروجرد",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126007",
            "name": "پلدختر",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126008",
            "name": "معمولان",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126009",
            "name": "چغلوندی",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126010",
            "name": "خرم آباد",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126011",
            "name": "زاغه",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126012",
            "name": "سپیددشت",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126013",
            "name": "نورآباد",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126014",
            "name": "هفت چشمه",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126015",
            "name": "سراب دوره",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126016",
            "name": "ویسیان",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126017",
            "name": "چالانچولان",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126018",
            "name": "دورود",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126019",
            "name": "الشتر",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126020",
            "name": "فیروزآباد",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126021",
            "name": "چقابل",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126022",
            "name": "درب گنبد",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126023",
            "name": "کونانی",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126024",
            "name": "کوهدشت",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126025",
            "name": "گراب",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "127001",
            "name": "آمل",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127002",
            "name": "دابودشت",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127003",
            "name": "رینه",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127004",
            "name": "گزنک",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127005",
            "name": "امیرکلا",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127006",
            "name": "بابل",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127007",
            "name": "خوش رودپی",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127008",
            "name": "زرگرمحله",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127009",
            "name": "گتاب",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127010",
            "name": "گلوگاه",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127011",
            "name": "مرزیکلا",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127012",
            "name": "بابلسر",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127013",
            "name": "بهنمیر",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127014",
            "name": "کله بست",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127015",
            "name": "بهشهر",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127016",
            "name": "خلیل شهر",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127017",
            "name": "رستمکلا",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127018",
            "name": "تنکابن",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127019",
            "name": "خرم آباد",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127020",
            "name": "شیرود",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127021",
            "name": "نشتارود",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127022",
            "name": "جویبار",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127023",
            "name": "کوهی خیل",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127024",
            "name": "چالوس",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127025",
            "name": "کلاردشت",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127026",
            "name": "مرزن آباد",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127027",
            "name": "رامسر",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127028",
            "name": "کتالم وسادات شهر",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127029",
            "name": "ساری",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127030",
            "name": "فریم",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127031",
            "name": "کیاسر",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127032",
            "name": "آلاشت",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127033",
            "name": "پل سفید",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127034",
            "name": "زیرآب",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127035",
            "name": "شیرگاه",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127037",
            "name": "عباس آباد",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127038",
            "name": "کلارآباد",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127039",
            "name": "فریدونکنار",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127040",
            "name": "قائم شهر",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127041",
            "name": "کیاکلا",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127042",
            "name": "سرخرود",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127043",
            "name": "محمودآباد",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127044",
            "name": "سورک",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127045",
            "name": "نکا",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127046",
            "name": "ایزدشهر",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127047",
            "name": "بلده",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127048",
            "name": "چمستان",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127049",
            "name": "رویان",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127050",
            "name": "نور",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127051",
            "name": "پول",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127052",
            "name": "نوشهر",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "128001",
            "name": "اراک",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128002",
            "name": "داودآباد",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128003",
            "name": "ساروق",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128004",
            "name": "سنجان",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128005",
            "name": "کارچان",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128006",
            "name": "کرهرود",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128007",
            "name": "آشتیان",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128008",
            "name": "تفرش",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128009",
            "name": "خمین",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128010",
            "name": "قورچی باشی",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128011",
            "name": "جاورسیان",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128012",
            "name": "خنداب",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128013",
            "name": "دلیجان",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128014",
            "name": "نراق",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128015",
            "name": "پرندک[3]",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128016",
            "name": "خشکرود",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128017",
            "name": "رازقان",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128018",
            "name": "زاویه",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128019",
            "name": "مامونیه",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128020",
            "name": "ساوه",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128021",
            "name": "غرق آباد",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128022",
            "name": "نوبران",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128023",
            "name": "آستانه سربند",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128024",
            "name": "توره",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128025",
            "name": "شازند",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128026",
            "name": "شهباز",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128027",
            "name": "مهاجران",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128028",
            "name": "هندودر",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128029",
            "name": "خنجین",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128030",
            "name": "فرمهین",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128031",
            "name": "کمیجان",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128032",
            "name": "میلاجرد",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128033",
            "name": "محلات",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128034",
            "name": "نیمور",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "128027",
            "name": "شهرجديدمهاجران",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "129001",
            "name": "ابوموسی",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129002",
            "name": "بستک",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129003",
            "name": "جناح",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129004",
            "name": "سردشت",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129005",
            "name": "گوهران",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129006",
            "name": "بندرعباس",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129007",
            "name": "تخت",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129008",
            "name": "فین",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129009",
            "name": "قلعه قاضی",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129010",
            "name": "بندرلنگه",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129011",
            "name": "چارک",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129012",
            "name": "کنگ",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129013",
            "name": "کیش",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129014",
            "name": "پارسیان",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129015",
            "name": "کوشکنار",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129016",
            "name": "بندرجاسک",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129017",
            "name": "فارغان",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129018",
            "name": "حاجی آباد",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129019",
            "name": "سرگز",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129020",
            "name": "خمیر",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129021",
            "name": "رویدر",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129022",
            "name": "بیکا",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129023",
            "name": "دهبارز",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129024",
            "name": "زیارتعلی",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129025",
            "name": "سیریک",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129026",
            "name": "درگهان",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129027",
            "name": "سوزا",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129028",
            "name": "قشم",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129029",
            "name": "هرمز",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129030",
            "name": "سندرک",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129031",
            "name": "میناب",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129032",
            "name": "هشتبندی",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129046",
            "name": "کوهستک",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "130001",
            "name": "اسدآباد",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130002",
            "name": "بهار",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130003",
            "name": "صالح آباد",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130004",
            "name": "لالجین",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130005",
            "name": "تویسرکان",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130006",
            "name": "سرکان",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130007",
            "name": "فرسفج",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130008",
            "name": "دمق",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130009",
            "name": "رزن",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130010",
            "name": "قروه درجزین",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130011",
            "name": "فامنین",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130012",
            "name": "شیرین سو",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130013",
            "name": "کبودرآهنگ",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130014",
            "name": "گل تپه",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130015",
            "name": "ازندریان",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130016",
            "name": "جوکار",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130017",
            "name": "زنگنه",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130018",
            "name": "سامن",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130019",
            "name": "ملایر",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130020",
            "name": "برزول",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130021",
            "name": "فیروزان",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130022",
            "name": "گیان",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130023",
            "name": "نهاوند",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130024",
            "name": "جورقان",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130025",
            "name": "قهاوند",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130026",
            "name": "مریانج",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130027",
            "name": "همدان",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "131001",
            "name": "ابرکوه",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131002",
            "name": "مهردشت",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131003",
            "name": "احمدآباد",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131004",
            "name": "اردکان",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131005",
            "name": "عقدا",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131006",
            "name": "بافق",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131007",
            "name": "بهاباد",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131008",
            "name": "تفت",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131009",
            "name": "نیر",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131010",
            "name": "مروست",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131011",
            "name": "هرات",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131012",
            "name": "اشکذر",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131013",
            "name": "خضرآباد",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131014",
            "name": "ندوشن",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131018",
            "name": "مهریز",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131019",
            "name": "بفروییه",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131020",
            "name": "میبد",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131021",
            "name": "حمیدیا",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131022",
            "name": "زارچ",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131023",
            "name": "شاهدیه",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "131024",
            "name": "یزد",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "118008",
            "name": "عصمت اباد",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "108045",
            "name": "تجریش",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "114018",
            "name": "ماهنشان",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "125055",
            "name": "ماکلوان",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125009",
            "name": "هشتپر",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "124001",
            "name": "ازاد شهر",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "127007",
            "name": "خوشرودپي",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127040",
            "name": "قايم شهر",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "province_id": "2",
            "city_code": "102046",
            "name": "نلاس",
            "province_code": "AZW"
        },
        {
            "province_id": "2",
            "city_code": "102048",
            "name": "حاجیلار",
            "province_code": "AZW"
        },
        {
            "province_id": "2",
            "city_code": "102017",
            "name": "قره ضياءالدين",
            "province_code": "AZW"
        },
        {
            "city_code": "120026",
            "name": "حسین اباد",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "130032",
            "name": "اجین",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "113046",
            "name": "فتح المبين",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113069",
            "name": "جولکی",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "106025",
            "name": "شباب",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "122035",
            "name": "گودین",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "107031",
            "name": "بندر ريگ",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107030",
            "name": "شيرينو",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "province_id": "23",
            "city_code": "123021",
            "name": "سراسیاب یوسفی",
            "province_code": "KOB"
        },
        {
            "city_code": "121070",
            "name": "بلورد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121077",
            "name": "سیریز",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "104113",
            "name": "زازران",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "129043",
            "name": "زهوکی",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129045",
            "name": "دشتی",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "121040",
            "name": "عنبراباد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "129044",
            "name": "تازیان پایین",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "131026",
            "name": "بخ",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "104018",
            "name": "اران و بيدگل",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104115",
            "name": "باغشاد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "province_id": "9",
            "city_code": "109018",
            "name": "هاروني",
            "province_code": "CHB"
        },
        {
            "province_id": "16",
            "city_code": "116048",
            "name": "پلان",
            "province_code": "SBA"
        },
        {
            "province_id": "16",
            "city_code": "116054",
            "name": "قرقری",
            "province_code": "SBA"
        },
        {
            "province_id": "16",
            "city_code": "116042",
            "name": "جزینک",
            "province_code": "SBA"
        },
        {
            "province_id": "16",
            "city_code": "116040",
            "name": "ریگ ملک",
            "province_code": "SBA"
        },
        {
            "province_id": "16",
            "city_code": "116033",
            "name": "نيکشهر",
            "province_code": "SBA"
        },
        {
            "city_code": "115021",
            "name": "کهن اباد",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "128035",
            "name": "تلخاب",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "119007",
            "name": "قاهان",
            "province_id": "19",
            "province_code": "QOM "
        },
        {
            "city_code": "127061",
            "name": "کجور",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "125053",
            "name": "ضیابر",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "province_id": "1",
            "city_code": "101069",
            "name": "علیشاه (علی اباد)",
            "province_code": "AZE"
        },
        {
            "province_id": "1",
            "city_code": "101030",
            "name": "شند اباد",
            "province_code": "AZE"
        },
        {
            "city_code": "124025",
            "name": "مينو دشت",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "127063",
            "name": "فرح اباد",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "124036",
            "name": "القجر",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "127060",
            "name": "ارطه",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "124004",
            "name": "انبار الوم",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "127034",
            "name": "زير اب",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "province_id": "2",
            "city_code": "102045",
            "name": "بکتاش",
            "province_code": "AZW"
        },
        {
            "city_code": "113081",
            "name": "گلگیر",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113030",
            "name": "شهرامام",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "126020",
            "name": "فيروز اباد",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "117104",
            "name": "معزابادجابری",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "126023",
            "name": "کوهناني",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "126009",
            "name": "بيران شهر",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "122031",
            "name": "ریجاب",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "122032",
            "name": "شروینه",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "107013",
            "name": "سعداباد",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107041",
            "name": "بوشکان",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107025",
            "name": "بندر ديلم",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "117085",
            "name": "نور اباد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "104109",
            "name": "زیار",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104103",
            "name": "اصغراباد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "129048",
            "name": "کوهیچ",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129040",
            "name": "کوخردهرنگ",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "province_id": "9",
            "city_code": "109040",
            "name": "سردشت لردگان",
            "province_code": "CHB"
        },
        {
            "city_code": "104054",
            "name": "بويين مياندشت",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "111092",
            "name": "جنت اباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "112020",
            "name": "قوشخانه",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "111048",
            "name": "سفيد سنگ",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "112023",
            "name": "یکه سعود",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "110032",
            "name": "درح",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "province_id": "16",
            "city_code": "116047",
            "name": "ساربوک",
            "province_code": "SBA"
        },
        {
            "city_code": "128037",
            "name": "شهرجدید امیرکبیر",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "105018",
            "name": "پلنگ اباد",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "105002",
            "name": "مهستان",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "108048",
            "name": "جلیل اباد",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "province_id": "1",
            "city_code": "101014",
            "name": "خسروشاه",
            "province_code": "AZE"
        },
        {
            "city_code": "124032",
            "name": "دوزین",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124023",
            "name": "گنبد کاووس",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124006",
            "name": "بندر گز",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "province_id": "2",
            "city_code": "102029",
            "name": "شاهيندژ",
            "province_code": "AZW"
        },
        {
            "city_code": "103029",
            "name": "قصابه",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103026",
            "name": "فیروزاباد",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103031",
            "name": "زیوه",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "113063",
            "name": "عنبر",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113089",
            "name": "ابژدان",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113075",
            "name": "شهیون",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113065",
            "name": "ابوحمیظه",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113067",
            "name": "عرب حسن",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "126026",
            "name": "شاپور اباد",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "province_id": "23",
            "city_code": "123017",
            "name": "سرفاریاب",
            "province_code": "KOB"
        },
        {
            "city_code": "117118",
            "name": "چاه ورز",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117120",
            "name": "میانشهر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117107",
            "name": "محمله",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117115",
            "name": "زنگی اباد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "province_id": "23",
            "city_code": "123019",
            "name": "بوستان",
            "province_code": "KOB"
        },
        {
            "city_code": "129037",
            "name": "لیردف",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "121071",
            "name": "علی اباد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "131027",
            "name": "خرانق",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "province_id": "9",
            "city_code": "109039",
            "name": "هوره",
            "province_code": "CHB"
        },
        {
            "city_code": "111076",
            "name": "چنار",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "province_id": "16",
            "city_code": "116038",
            "name": "پارود",
            "province_code": "SBA"
        },
        {
            "city_code": "108043",
            "name": "قیامدشت",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "118026",
            "name": "زیاران",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "city_code": "108037",
            "name": "جواد اباد",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "125046",
            "name": "چاف وچمخاله",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "114019",
            "name": "نوربهار",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "124026",
            "name": "گلیداغ",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "province_id": "1",
            "city_code": "101062",
            "name": "دیزج حسین بیگ",
            "province_code": "AZE"
        },
        {
            "city_code": "124024",
            "name": "مراوه تپه",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "127059",
            "name": "دالخانی",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "province_id": "1",
            "city_code": "101055",
            "name": "نظر کهريزي",
            "province_code": "AZE"
        },
        {
            "city_code": "103030",
            "name": "النی",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "120032",
            "name": "اورامان تخت",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "130028",
            "name": "اسلامشهر اق گل",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "113071",
            "name": "منتظران",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "126027",
            "name": "سراب حمام",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "106022",
            "name": "ماژین",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "117100",
            "name": "خوزی",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "107034",
            "name": "بادوله",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "117097",
            "name": "بیدشهر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "129050",
            "name": "کرگان",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "province_id": "9",
            "city_code": "109012",
            "name": "شهر کرد",
            "province_code": "CHB"
        },
        {
            "province_id": "9",
            "city_code": "109043",
            "name": "فیل اباد",
            "province_code": "CHB"
        },
        {
            "province_id": "16",
            "city_code": "116043",
            "name": "اسفندک",
            "province_code": "SBA"
        },
        {
            "city_code": "108044",
            "name": "قلعه نو",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108018",
            "name": "رباطکريم",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "115018",
            "name": "رویان",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "127055",
            "name": "هچیرود",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "125036",
            "name": "احمد سر گوراب",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "125018",
            "name": "لشت نشاء",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "127008",
            "name": "زرگر",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "113083",
            "name": "کوت عبدالله",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "province_id": "2",
            "city_code": "102013",
            "name": "لاجان",
            "province_code": "AZW"
        },
        {
            "city_code": "103004",
            "name": "جعفر اباد",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103034",
            "name": "اسلام اباد",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "120031",
            "name": "پیرتاج",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "130031",
            "name": "کرفس",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "113068",
            "name": "شمس اباد",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113077",
            "name": "خنافره",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113078",
            "name": "منصوریه",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "126031",
            "name": "چمن سلطان",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "province_id": "23",
            "city_code": "123018",
            "name": "قلعه ممبی",
            "province_code": "KOB"
        },
        {
            "city_code": "117119",
            "name": "قره بلاغ",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "107038",
            "name": "بید خون",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "129051",
            "name": "تنب بزرگ",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129034",
            "name": "لمزان",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "111095",
            "name": "ریوند",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "108046",
            "name": "خسرو اباد",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "105010",
            "name": "کمالشهر",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "city_code": "127042",
            "name": "سرخ رود",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "province_id": "1",
            "city_code": "101006",
            "name": "اذر شهر",
            "province_code": "AZE"
        },
        {
            "province_id": "1",
            "city_code": "101073",
            "name": "تیمورلو",
            "province_code": "AZE"
        },
        {
            "province_id": "1",
            "city_code": "101065",
            "name": "اسفهلان",
            "province_code": "AZE"
        },
        {
            "province_id": "1",
            "city_code": "101003",
            "name": "شهرجديدسهند",
            "province_code": "AZE"
        },
        {
            "city_code": "127054",
            "name": "طبقده",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127011",
            "name": "مرزي کلا",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "113082",
            "name": "الهایی",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "province_id": "2",
            "city_code": "102039",
            "name": "چهار برج",
            "province_code": "AZW"
        },
        {
            "province_id": "1",
            "city_code": "101064",
            "name": "مبارک شهر",
            "province_code": "AZE"
        },
        {
            "city_code": "103027",
            "name": "ثمرین",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "130033",
            "name": "شاهنجرین",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "113086",
            "name": "جندی شاپور",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "106026",
            "name": "دشت عباس",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "117098",
            "name": "طسوج",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117116",
            "name": "سلطان شهر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "122010",
            "name": "کرندغرب",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "107009",
            "name": "ابپخش",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "117121",
            "name": "دهکویه",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117106",
            "name": "خیرگو",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "121074",
            "name": "کشکوییه",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121083",
            "name": "هنزا",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121078",
            "name": "دشتکار",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "province_id": "23",
            "city_code": "123020",
            "name": "سپیدار",
            "province_code": "KOB"
        },
        {
            "city_code": "121065",
            "name": "چاه مرید",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "129039",
            "name": "پل",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "121082",
            "name": "حور پاسفید",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "104102",
            "name": "ویست",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "112007",
            "name": "سنخواست (جديد)",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "111090",
            "name": "حکم اباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "province_id": "16",
            "city_code": "116045",
            "name": "لادیز",
            "province_code": "SBA"
        },
        {
            "province_id": "16",
            "city_code": "116055",
            "name": "اسماعیل اباد",
            "province_code": "SBA"
        },
        {
            "province_id": "16",
            "city_code": "116046",
            "name": "بریس",
            "province_code": "SBA"
        },
        {
            "province_id": "16",
            "city_code": "116050",
            "name": "گتیج",
            "province_code": "SBA"
        },
        {
            "city_code": "108040",
            "name": "شهرجديدپرند",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "114021",
            "name": "نیکپی",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "124037",
            "name": "مزرعه",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "province_id": "2",
            "city_code": "102043",
            "name": "یولاگلدی",
            "province_code": "AZW"
        },
        {
            "city_code": "103007",
            "name": "مغانسر",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "113085",
            "name": "رود زرد ماشین",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "126028",
            "name": "برخوردار",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "120029",
            "name": "سنته",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "122033",
            "name": "بان وره",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "117102",
            "name": "فتح اباد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "104106",
            "name": "مینادشت",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "129038",
            "name": "شمیل",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "121067",
            "name": "بلوک",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "131025",
            "name": "مجومرد",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "104104",
            "name": "دهسرخ",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104099",
            "name": "خالدا باد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104114",
            "name": "طرق رود",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "province_id": "9",
            "city_code": "109004",
            "name": "سفيد دشت",
            "province_code": "CHB"
        },
        {
            "city_code": "111083",
            "name": "مزرج",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111094",
            "name": "رادکان",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "province_id": "16",
            "city_code": "116041",
            "name": "چگرد",
            "province_code": "SBA"
        },
        {
            "city_code": "115019",
            "name": "کلاته",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "108025",
            "name": "شهر جديد انديشه",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "127062",
            "name": "بابکان",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "province_id": "1",
            "city_code": "101070",
            "name": "اچاچی",
            "province_code": "AZE"
        },
        {
            "province_id": "1",
            "city_code": "101059",
            "name": "لاهیجان",
            "province_code": "AZE"
        },
        {
            "city_code": "103033",
            "name": "اراللو",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103032",
            "name": "بران علیا",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "113087",
            "name": "چم گلک",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113072",
            "name": "سیاه منصور",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113084",
            "name": "باوج",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "126012",
            "name": "سپيد دشت",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "117099",
            "name": "رحمت اباد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "126032",
            "name": "ونایی",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "117064",
            "name": "کنار تخته",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117110",
            "name": "باغ صفا",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "129022",
            "name": "بيکاه",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "104105",
            "name": "طاد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "131021",
            "name": "حمیدیا",
            "province_id": "31",
            "province_code": "YAZ"
        },
        {
            "city_code": "108047",
            "name": "سعیداباد",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "108003",
            "name": "صالحيه",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "province_id": "1",
            "city_code": "101067",
            "name": "داریان",
            "province_code": "AZE"
        },
        {
            "province_id": "1",
            "city_code": "101060",
            "name": "خوشه مهر",
            "province_code": "AZE"
        },
        {
            "city_code": "124033",
            "name": "سیجوال",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "113070",
            "name": "تراز",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "117117",
            "name": "پاسخن",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117108",
            "name": "فال",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117043",
            "name": "شهرجديدصدرا",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "121069",
            "name": "گنبکی",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121066",
            "name": "دهکهان",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "121073",
            "name": "زهکلوت",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "112004",
            "name": "حصار گرمخان",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "111077",
            "name": "شهرکهنه",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "112025",
            "name": "چناران شهر",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "110030",
            "name": "ابیز",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "108011",
            "name": "شهرجديدپرديس",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "128036",
            "name": "اوه",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "city_code": "125054",
            "name": "طاهرگوراب",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "province_id": "1",
            "city_code": "101071",
            "name": "کردکندی",
            "province_code": "AZE"
        },
        {
            "city_code": "127057",
            "name": "اکند",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "124028",
            "name": "فراغی",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124030",
            "name": "ینقاق",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "province_id": "2",
            "city_code": "102047",
            "name": "گوگ تپه",
            "province_code": "AZW"
        },
        {
            "city_code": "113064",
            "name": "تشان",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "106023",
            "name": "چشمه شیرین",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "107033",
            "name": "دوراهک",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "117114",
            "name": "بابامنیر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "121080",
            "name": "دهنو اسلام اباد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "104060",
            "name": "اشتر جان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104111",
            "name": "سین",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "129033",
            "name": "تیرور",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "112024",
            "name": "زیارت",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "111088",
            "name": "نوده انقلاب",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "108020",
            "name": "باقر شهر",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "115020",
            "name": "رضوان",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "city_code": "115017",
            "name": "مهديشهر",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "province_id": "1",
            "city_code": "101066",
            "name": "عاشقلو",
            "province_code": "AZE"
        },
        {
            "city_code": "124035",
            "name": "سنگدوین",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "127053",
            "name": "استانه سرا",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "103028",
            "name": "اردیموسی",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "103025",
            "name": "زهرا",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "120030",
            "name": "مالوجه",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "113080",
            "name": "زاووت",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "130029",
            "name": "پالیز",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "130010",
            "name": "قروه درگزين",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "city_code": "106024",
            "name": "بلاوه",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "city_code": "107040",
            "name": "عالی شهر",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "117113",
            "name": "رستاق",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "107037",
            "name": "اباد",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "117109",
            "name": "فاروق",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "129049",
            "name": "بالاشهر",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "104110",
            "name": "بوستان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "129041",
            "name": "بندزرک",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129036",
            "name": "رمکان",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "129035",
            "name": "طبل",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "104107",
            "name": "فتح اباد",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "111085",
            "name": "سیداباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111086",
            "name": "گلبهار",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "province_id": "16",
            "city_code": "116049",
            "name": "اشار",
            "province_code": "SBA"
        },
        {
            "province_id": "1",
            "city_code": "101061",
            "name": "لاریجان",
            "province_code": "AZE"
        },
        {
            "province_id": "1",
            "city_code": "101072",
            "name": "جوان قلعه",
            "province_code": "AZE"
        },
        {
            "province_id": "1",
            "city_code": "101039",
            "name": "بناب مرند",
            "province_code": "AZE"
        },
        {
            "city_code": "124029",
            "name": "تاتارعلیا",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "124034",
            "name": "قرق",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "province_id": "2",
            "city_code": "102044",
            "name": "تخت سلیمان",
            "province_code": "AZW"
        },
        {
            "city_code": "117094",
            "name": "خیراباد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117105",
            "name": "ارد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117101",
            "name": "اکبراباد",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117112",
            "name": "خانیمن",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "121084",
            "name": "علی اباد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "129042",
            "name": "گروک",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "104108",
            "name": "جوشقان قالی",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104088",
            "name": "شهر جديد مجلسي",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "111075",
            "name": "سمیع اباد",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111089",
            "name": "روشناوند",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "111082",
            "name": "ریواده",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "127036",
            "name": "سلمانشهر",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "127056",
            "name": "امام زاده عبدالله",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "125052",
            "name": "پیربازار",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "127064",
            "name": "پایین هولار",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "124031",
            "name": "صادق اباد",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "city_code": "127014",
            "name": "هادي شهر",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "city_code": "120028",
            "name": "توپ اغاج",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "113066",
            "name": "کوت سیدنعیم",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "113079",
            "name": "سرداران",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "126029",
            "name": "سوری",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "117122",
            "name": "مظفری",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "121075",
            "name": "رحمت اباد",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "104112",
            "name": "قهجاورستان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "121072",
            "name": "چاه دادخدا",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "111093",
            "name": "چخماق",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "112022",
            "name": "غلامان",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "111091",
            "name": "قلعه نوعلیا",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "province_id": "16",
            "city_code": "116039",
            "name": "ده رییس",
            "province_code": "SBA"
        },
        {
            "city_code": "108029",
            "name": "صبا شهر",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "city_code": "114020",
            "name": "کرسف",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "city_code": "125050",
            "name": "بازار جمعه",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "city_code": "113088",
            "name": "شیرین شهر",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "126030",
            "name": "چم پلک",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "city_code": "107039",
            "name": "چاه مبارک",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "107036",
            "name": "نخل تقی",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "city_code": "117103",
            "name": "مزایجان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "129047",
            "name": "هنگویه",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "city_code": "104067",
            "name": "کامووچوگان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "104101",
            "name": "بیده",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "city_code": "111081",
            "name": "نسر",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "city_code": "112026",
            "name": "یکه سعود (جدید)",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "city_code": "110029",
            "name": "ماژان",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "city_code": "111079",
            "name": "فرگ قلعه",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "province_id": "1",
            "city_code": "101068",
            "name": "نظرلو",
            "province_code": "AZE"
        },
        {
            "city_code": "103035",
            "name": "اولتان",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "city_code": "120027",
            "name": "برده رشه",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "city_code": "113076",
            "name": "میانکوه",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "city_code": "122034",
            "name": "قلعه",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "city_code": "117095",
            "name": "کوره",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117073",
            "name": "عمادشهر",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117096",
            "name": "کوپن",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "117111",
            "name": "مادرسلیمان",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "city_code": "121079",
            "name": "جوادیه الهیه",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "city_code": "111084",
            "name": "الماجق",
            "province_id": "11",
            "province_code": "KHR"
        },
    ];

export const province_codes =
    [
        {
            "name": "آذربایجان شرقی",
            "province_id": "1",
            "province_code": "AZE"
        },
        {
            "name": "آذربایجان غربی",
            "province_id": "2",
            "province_code": "AZW"
        },
        {
            "name": "اردبیل",
            "province_id": "3",
            "province_code": "ARD"
        },
        {
            "name": "اصفهان",
            "province_id": "4",
            "province_code": "ESF"
        },
        {
            "name": "البرز",
            "province_id": "5",
            "province_code": "ALB"
        },
        {
            "name": "ایلام",
            "province_id": "6",
            "province_code": "EIL"
        },
        {
            "name": "بوشهر",
            "province_id": "7",
            "province_code": "BSH"
        },
        {
            "name": "تهران",
            "province_id": "8",
            "province_code": "THR"
        },
        {
            "name": "چهارمحال و بختیاری",
            "province_id": "9",
            "province_code": "CHB"
        },
        {
            "name": "خراسان جنوبی",
            "province_id": "10",
            "province_code": "KHS"
        },
        {
            "name": "خراسان رضوی",
            "province_id": "11",
            "province_code": "KHR"
        },
        {
            "name": "خراسان شمالی",
            "province_id": "12",
            "province_code": "KHN"
        },
        {
            "name": "خوزستان",
            "province_id": "13",
            "province_code": "KHO"
        },
        {
            "name": "زنجان",
            "province_id": "14",
            "province_code": "ZNJ"
        },
        {
            "name": "سمنان",
            "province_id": "15",
            "province_code": "SEM"
        },
        {
            "name": "سیستان و بلوچستان",
            "province_id": "16",
            "province_code": "SBA"
        },
        {
            "name": "فارس",
            "province_id": "17",
            "province_code": "FAR"
        },
        {
            "name": "قزوین",
            "province_id": "18",
            "province_code": "QAZ"
        },
        {
            "name": "قم",
            "province_id": "19",
            "province_code": "QOM "
        },
        {
            "name": "کردستان",
            "province_id": "20",
            "province_code": "KRD"
        },
        {
            "name": "کرمان",
            "province_id": "21",
            "province_code": "KRM"
        },
        {
            "name": "کرمانشاه",
            "province_id": "22",
            "province_code": "KSH"
        },
        {
            "name": "کهگیلویه و بویراحمد",
            "province_id": "23",
            "province_code": "KOB"
        },
        {
            "name": "گلستان",
            "province_id": "24",
            "province_code": "GOL"
        },
        {
            "name": "گیلان",
            "province_id": "25",
            "province_code": "GIL"
        },
        {
            "name": "لرستان",
            "province_id": "26",
            "province_code": "LOR"
        },
        {
            "name": "مازندران",
            "province_id": "27",
            "province_code": "MAZ"
        },
        {
            "name": "مرکزی",
            "province_id": "28",
            "province_code": "MAR"
        },
        {
            "name": "هرمزگان",
            "province_id": "29",
            "province_code": "HOR"
        },
        {
            "name": "همدان",
            "province_id": "30",
            "province_code": "HAM"
        },
        {
            "name": "یزد",
            "province_id": "31",
            "province_code": "YAZ"
        },
    ];

export const provinceCities = function (province_code)
{
    if (!province_code) {
        return []
    }

    return city_codes.filter(
        city => city.province_code === province_code
    );
}
